import { Component, JSXElement, Show } from 'solid-js';

export interface ActiveIndicatorChipProps {
  readonly icon?: string;
  readonly svgIcon?: string;
  readonly tooltip: string;
  readonly tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  readonly testId?: string;
}

const ActiveIndicatorChip: Component<ActiveIndicatorChipProps> = (
  props
): JSXElement => {
  return (
    <modus-wc-tooltip
      content={props.tooltip}
      position={props.tooltipPosition ?? 'right'}
    >
      <span data-testid={props.testId}>
        <Show
          when={!props.svgIcon}
          fallback={
            <modus-wc-chip shape="circle" size="md" variant="filled" active>
              <img src={props.svgIcon} alt="" class="block w-5 h-5" />
            </modus-wc-chip>
          }
        >
          <modus-wc-chip shape="circle" size="md" variant="filled" active>
            <modus-wc-icon
              size="sm"
              class="flex justify-center items-center"
              custom-class={
                props.icon?.startsWith('tc-icon')
                  ? `icon-font ${props.icon} i16 flex justify-center items-center`
                  : 'flex justify-center items-center'
              }
              name={props.icon?.startsWith('tc-icon') ? undefined : props.icon}
            />
          </modus-wc-chip>
        </Show>
      </span>
    </modus-wc-tooltip>
  );
};

export default ActiveIndicatorChip;
